<template>
  <v-footer
    color="primary"
    absolute
    app
  >
    <span class="white--text">&copy; 2026</span>
    <v-spacer />
    <span class="white--text">version <span id="app-version">{{ version }}</span></span>
  </v-footer>
</template>

<script>
  export default {
    name: 'AppFooter',

    computed: {
      version () {
        return process.env.VUE_APP_VERSION
      },
    },
  }
</script>

<style scoped>

</style>
